import Vue from 'vue';
export function requestAiAnalysis(http, type, filters) {
    return http({
        url: Vue.config.analyticsURL + '/' + type,
        method: 'POST',
        data: filters,
        responseType: 'text',
        transformResponse: [(data) => data],
    }).then((resp) => resp.data);
}

export function openAiAnalysis(http, type, filters) {
    const tab = window.open('', '_blank');
    if (tab) {
        tab.document.write(
            '<!doctype html><meta charset="utf-8"><title>Анализ ИИ</title>'
            + '<body style="font-family:sans-serif;padding:32px;color:#555">Формируется анализ ИИ, подождите…</body>'
        );
    }

    return requestAiAnalysis(http, type, filters)
        .then((html) => {
            const url = URL.createObjectURL(new Blob([html], {type: 'text/html'}));
            if (tab) {
                tab.location.href = url;
            } else {
                window.open(url, '_blank');
            }
        })
        .catch((err) => {
            console.log(err);
            if (tab) {
                tab.document.open();
                tab.document.write(
                    '<!doctype html><meta charset="utf-8"><title>Анализ ИИ</title>'
                    + '<body style="font-family:sans-serif;padding:32px;color:#b00">Не удалось получить анализ ИИ. Попробуйте позже.</body>'
                );
                tab.document.close();
            }
        });
}
